module.exports = __webpack_public_path__ + "assets/lowest.92b1345d.svg";